import React from "react";
import { NavLink } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

interface NavItem {
  to: string;
  label: string;
  perms?: string[];
}

const NAV_ITEMS: NavItem[] = [
  { to: "/", label: "Dashboard" },
  { to: "/assets", label: "Asset Register", perms: ["*", "asset:view", "asset:manage"] },
  { to: "/work-orders", label: "Work Orders" },
  { to: "/requests", label: "Maintenance Requests" },
  { to: "/pm-scheduler", label: "PM Scheduler", perms: ["*", "pm:manage"] },
  { to: "/spare-parts", label: "Spare Parts", perms: ["*", "inventory:issue", "inventory:receive", "inventory:adjust"] },
  { to: "/reports", label: "Reports", perms: ["*", "reports:view"] },
  { to: "/admin", label: "Administration", perms: ["*", "user:manage", "master:manage"] },
];

export const Sidebar: React.FC<{ open: boolean; onNavigate?: () => void }> = ({ open, onNavigate }) => {
  const { hasPermission } = useAuth();
  const items = NAV_ITEMS.filter((item) => !item.perms || hasPermission(...item.perms));

  return (
    <aside
      className={`fixed inset-y-0 left-0 z-40 w-64 transform bg-industrial-900 text-slate-100 transition-transform lg:static lg:translate-x-0 ${
        open ? "translate-x-0" : "-translate-x-full"
      }`}
    >
      <div className="flex h-16 items-center gap-2 px-5 border-b border-industrial-700">
        <div className="flex h-8 w-8 items-center justify-center rounded bg-accent-500 font-bold">C</div>
        <span className="font-semibold tracking-wide">CMMS on Cloud</span>
      </div>
      <nav className="flex flex-col gap-1 p-3">
        {items.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.to === "/"}
            onClick={onNavigate}
            className={({ isActive }) =>
              `rounded-md px-3 py-2 text-sm font-medium transition-colors ${
                isActive ? "bg-accent-500 text-white" : "text-slate-300 hover:bg-industrial-700"
              }`
            }
          >
            {item.label}
          </NavLink>
        ))}
      </nav>
    </aside>
  );
};
